import { useEffect, useState } from "react";
import { Heart, X } from "lucide-react";
import { LOVE_NOTES } from "@/lib/constants";

/**
 * Clickable hearts pinned to corners of the screen. Tapping reveals a love note.
 */
const PINS = [
  { id: "tl", style: { top: "20%", left: "4%" }, delay: "0s" },
  { id: "br", style: { bottom: "30%", right: "5%" }, delay: "1.6s" },
  { id: "ml", style: { top: "55%", left: "3%" }, delay: "3s" },
];

export default function LoveNotes() {
  const [openId, setOpenId] = useState(null);
  const [note, setNote] = useState(LOVE_NOTES[0]);

  useEffect(() => {
    if (openId) {
      const t = setTimeout(() => setOpenId(null), 4200);
      return () => clearTimeout(t);
    }
  }, [openId]);

  const handleTap = (id) => {
    const next = LOVE_NOTES[Math.floor(Math.random() * LOVE_NOTES.length)];
    setNote(next);
    setOpenId(id);
  };

  return (
    <div data-testid="love-notes-root" className="pointer-events-none fixed inset-0 z-30">
      {PINS.map((p) => (
        <div key={p.id} className="absolute" style={p.style}>
          <button
            type="button"
            onClick={() => handleTap(p.id)}
            data-testid={`love-note-heart-${p.id}`}
            aria-label="Reveal love note"
            className="pointer-events-auto group relative w-11 h-11 rounded-full bg-ink-900/60 backdrop-blur-md border border-gold/30 hover:border-gold flex items-center justify-center heart-tap transition-all duration-500 hover:scale-110"
            style={{ animationDelay: p.delay }}
          >
            <Heart
              size={18}
              className="text-burgundy-glow group-hover:text-gold transition-colors"
              fill="currentColor"
            />
          </button>

          {openId === p.id && (
            <div
              data-testid={`love-note-popup-${p.id}`}
              className="pointer-events-auto absolute top-12 left-0 min-w-[220px] glass-card px-4 py-3 animate-fade-up"
              style={{ animationDuration: "0.5s" }}
            >
              <button
                type="button"
                onClick={() => setOpenId(null)}
                className="absolute top-1 right-1 text-ivory-dim hover:text-gold p-1"
                aria-label="Close"
                data-testid={`love-note-close-${p.id}`}
              >
                <X size={12} />
              </button>
              <p className="font-serif italic text-base text-ivory pr-3">{note}</p>
              <p className="mt-1 text-[0.6rem] uppercase tracking-[0.32em] text-gold">
                #PandA
              </p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
